import { Component, Renderer2, OnChanges, Input, Output, EventEmitter, Inject, ViewChild, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { IntageHelper } from 'src/app/components/pages/intage/intage_helper';
import { AnalyticsHelper } from 'src/app/helpers/analytics';
import html2canvas from 'src/html2canvas';
import { downloadAsPDF as _downloadAsPDF } from './../../../../helpers/pdf';
import { IndexDbHelper } from 'src/app/helpers/indexDb';
import { getChartStateFromUrl } from 'src/app/helpers/queryString';
import { Router } from '@angular/router';

@Component({
  selector: 'intage-otc-market-size',
  templateUrl: './otc-market-size.component.html',
  styleUrls: ['./otc-market-size.component.scss']
})
export class IntageOtcMarketSizeComponent implements OnChanges {
  @Output() ready = new EventEmitter<boolean>();
  @Input() intageMonth: any;
  @Input() selectedWeek: string;
  @Input() intage: any;
  @Input() users: any;
  //FPT-MyNT15 [2022/11/30][SENSE][1203444563290052] Intage OTC report add download PNG
  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;
  @ViewChild('scroll') scroller: ElementRef;
  weeks: any;
  categories: any;
  data: any;
  categoryColors: any;
  marketShareData: any;
  makerLogo: any;
  summaryRegions: any;
  summaryPackageTypes: any;
  otcDisplayChannel: string;
  otcSelectedRegion: any;
  otcSelectedPackageType: any;
  marketShareData2: any;
  populated: boolean;
  aggregateBy: any;
  chartId = "otc-market-value-share-by-category"

  constructor(public datepipe: DatePipe, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private http: HttpClient, private router: Router) { }

  ngOnInit() {
    const chartState = getChartStateFromUrl(this.router, this.chartId);
    for (const key in chartState) {
      this[key] = chartState[key]
    }
  }

  ngOnChanges() {
    if(!this.populated){
      this.otcSelectedRegion = ['CCBJI Territory'];
      this.otcSelectedPackageType = ['All'];
      this.otcDisplayChannel = '1';
      this.categoryColors = IntageHelper.CategoryColors();
      this.makerLogo = IntageHelper.MakerLogos();
      this.populated = true;
    }
    if(this.intage != null && this.intageMonth != null && this.selectedWeek != null){
      this.categories = IntageHelper.Categories();
      this.summaryRegions = IntageHelper.Regions();
      this.summaryPackageTypes = IntageHelper.PackageType();
      this.handleMarketSize();
      this.handleMarketShare2();
    }
  }
  onChangeCheckBox(event) {
    AnalyticsHelper.hanldeCheckBoxSelect(event);
  }
  SaveOptionValueTemp(rollBack: boolean) {
    if (!rollBack) {
      window["otcSelectedRegion"] = [...this.otcSelectedRegion];
      window["otcSelectedPackageType"] = [...this.otcSelectedPackageType];
    } else {
      this.otcSelectedRegion = window["otcSelectedRegion"];
      this.otcSelectedPackageType = window["otcSelectedPackageType"];
    }
  }
  onRemoveFilterOTCRegion($event) {
    if(this.otcSelectedRegion.length == 0){
      this.otcSelectedRegion = ['CCBJI Territory'];
      this.SaveOptionValueTemp(false);
      this.onOtcSelectedRegionChange()
    }
    if ($event.value === 'CCBJI Territory') {
      this.otcSelectedRegion = [];
      return;
    }
  }
  onAddFilterOTCRegion($event) {
    if ($event === 'CCBJI Territory') {
      this.otcSelectedRegion = ['CCBJI Territory'];
      return;
    }
    if(this.otcSelectedRegion.filter(x=> x!='CCBJI Territory').length == (this.summaryRegions.length-1)){
      this.otcSelectedRegion = ['CCBJI Territory'];
    }else{
      this.otcSelectedRegion = this.otcSelectedRegion.filter(e => e !== 'CCBJI Territory');;
    }
  }
  onRemoveFilterOTCPackageType($event) {
    if(this.otcSelectedPackageType.length == 0){
      this.otcSelectedPackageType = ['All'];
      this.SaveOptionValueTemp(false);
      this.onOtcSelectedPackageTypeChange()
    }
    if ($event.value === 'All') {
      this.otcSelectedPackageType = [];
      return;
    }
  }
  onAddFilterOTCPackageType($event) {
    if ($event === 'All') {
      this.otcSelectedPackageType = ['All'];
      return;
    }
    if(this.otcSelectedPackageType.filter(x=> x!='All').length == (this.summaryPackageTypes.length-1)){
      this.otcSelectedPackageType = ['All'];
    }else{
      this.otcSelectedPackageType = this.otcSelectedPackageType.filter(e => e !== 'All');;
    }
  }

  handleMarketSize(){
    switch (this.aggregateBy) {
      case 'mtd':
        var month = this.intageMonth.find(x => x.week == this.selectedWeek).month;
        var weeks = [...new Set(this.intageMonth.filter(x => x.month == month && x.week <= this.selectedWeek).map(x=> x.week))];
        window["weeks"] = weeks;
        this.firstcheckIntageAllData();
        break;
      case 'qtd':
        var quarter = this.intageMonth.find(x => x.week == this.selectedWeek).quarter;
        var weeks = [...new Set(this.intageMonth.filter(x => x.quarter == quarter && x.week <= this.selectedWeek).map(x=> x.week))];
        window["weeks"] = weeks;
        this.firstcheckIntageAllData();      
        break;
      case 'ytd':
        var year = this.intageMonth.find(x => x.week == this.selectedWeek).year;
        var weeks = [...new Set(this.intageMonth.filter(x => x.year == year && x.week <= this.selectedWeek).map(x=> x.week))];
        window["weeks"] = weeks;
        this.firstcheckIntageAllData(); 
        break;
      default:
        weeks = [this.selectedWeek];
        this.handleIntageData(weeks);
        break;
    }
  }

  public async firstcheckIntageAllData()
  {
    var intage = await IndexDbHelper.Get('IntageFlashAllData'); 
    if (intage != null)
    {
      this.intage = intage;
      this.handleIntageData(window["weeks"]);
    }
    else
    {
      this.checkIntageFlashAllData();
    }
  }

  public async checkIntageFlashAllData()
  {
    setTimeout(async () => {
      var intage = await IndexDbHelper.Get('IntageFlashAllData');  
      if (intage != null)
      {
        this.intage = intage;
        this.handleIntageData(window["weeks"]);
      }
      else
      {
        this.checkIntageFlashAllData();
      }
    }, 200);
  }

  public handleIntageData(weeks: any)
  {
    var temp = this.intage.filter(x=> weeks.includes(x.week));
    let totalChannel = {
      channel: 'OTC Total',
      categories: [{
        category: 'Total',
        vsLy:'',
        imp: 100.0,
        ty: 0,
        ly: 0
      }]
    };
    let smddChannel = {
      channel: 'SMDD',
      categories: [{
        category: 'Total',
        vsLy:'',
        imp: 100.0,
        ty: 0,
        ly: 0
      }]
    };
    this.data = [totalChannel, smddChannel];
    for(var i=0;i<temp.length;i++){
      let row = temp[i];
      if(!this.otcSelectedRegion.includes('CCBJI Territory') && !this.otcSelectedRegion.includes(row.region)){
        continue;
      }
      if(!this.otcSelectedPackageType.includes('All') && !this.otcSelectedPackageType.includes(row.packageType)){
        continue;
      }
      let channel = this.data.find(x=> x.channel == row.channel);
      if(channel == null){
        channel = {
          channel: row.channel,
          categories: [{
            category: 'Total',
            vsLy:'',
            imp: 100.0,
            ty: 0,
            ly: 0
          }]
        }
        this.data.push(channel);
      }
      let category = channel.categories.find(x=> x.category == row.category);
      if(category == null){
        category = {
          category: row.category,
          vsLy:'',
          imp: 0,
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
        }
        channel.categories.push(category);
      }else{
        category.ty+=parseFloat(row.ty);
        category.ly+=parseFloat(row.ly);
      }
      let totalCategory = totalChannel.categories.find(x=> x.category == row.category);
      if(totalCategory == null){
        totalCategory = {
          category: row.category,
          vsLy:'',
          imp: 0,
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
        }
        totalChannel.categories.push(totalCategory);
      }else{
        totalCategory.ty+=parseFloat(row.ty);
        totalCategory.ly+=parseFloat(row.ly);
      }
      channel.categories[0].ty+=parseFloat(row.ty);
      channel.categories[0].ly+=parseFloat(row.ly);
      totalChannel.categories[0].ty+=parseFloat(row.ty);
      totalChannel.categories[0].ly+=parseFloat(row.ly);
      if(row.channel == 'Drug' || row.channel == 'SM' || row.channel == 'Discounter'){
        let smddCategory = smddChannel.categories.find(x=> x.category == row.category);
        if(smddCategory == null){
          smddCategory = {
            category: row.category,
            vsLy:'',
            imp: 0,
            ty: parseFloat(row.ty),
            ly: parseFloat(row.ly),
          }
          smddChannel.categories.push(smddCategory);
        }else{
          smddCategory.ty+=parseFloat(row.ty);
          smddCategory.ly+=parseFloat(row.ly);
        }
        smddChannel.categories[0].ty+=parseFloat(row.ty);
        smddChannel.categories[0].ly+=parseFloat(row.ly);
      }
    }

    for(var i=0;i<this.data.length;i++){
      for(var j=0;j<this.data[i].categories.length;j++){
        let category = this.data[i].categories[j];
        if (category.ly == 0)
        {
          category.vsLy = '-';
        }
        else if (category.ty == 0)
        {
          category.vsLy = '-100.0';
        }
        else
        {
          category.vsLy = ((category.ty/category.ly) * 100 - 100).toFixed(1);
        }

        category.imp = this.data[i].categories[0].ty == 0 ? "-" : (category.ty / this.data[i].categories[0].ty * 100).toFixed(1);
      }
    }

    if(this.otcDisplayChannel == '1'){
      this.data = this.data.filter(x=> x.channel != 'SM' && x.channel!= 'Drug' && x.channel!= 'Discounter');
    }
    else{
      this.data = this.data.filter(x=> x.channel != 'SMDD');
    }
  }
  
  onOTCMarketsizeAggregateChange(aggregateBy: string)
  {
    this.aggregateBy = aggregateBy;
    this.handleMarketSize();
    this.handleMarketShare2();
  }

  handleMarketShare2(){
    switch (this.aggregateBy) {
      case 'mtd':
        var month = this.intageMonth.find(x => x.week == this.selectedWeek).month;
        var weeks = [...new Set(this.intageMonth.filter(x => x.month == month && x.week <= this.selectedWeek).map(x=> x.week))];
        window["weeks"] = weeks;
        this.firstcheckIntageAllDataMarketShare();
        break;
      case 'qtd':
        var quarter = this.intageMonth.find(x => x.week == this.selectedWeek).quarter;
        var weeks = [...new Set(this.intageMonth.filter(x => x.quarter == quarter && x.week <= this.selectedWeek).map(x=> x.week))];
        window["weeks"] = weeks;
        this.firstcheckIntageAllDataMarketShare();      
        break;
      case 'ytd':
        var year = this.intageMonth.find(x => x.week == this.selectedWeek).year;
        var weeks = [...new Set(this.intageMonth.filter(x => x.year == year && x.week <= this.selectedWeek).map(x=> x.week))];
        window["weeks"] = weeks;
        this.firstcheckIntageAllDataMarketShare(); 
        break;
      default:
        weeks = [this.selectedWeek];
        this.handleIntageDataMarketShare(weeks);
        break;
    }
  }

  public async firstcheckIntageAllDataMarketShare()
  {
    var intage = await IndexDbHelper.Get('IntageFlashAllData'); 
    if (intage != null)
    {
      this.intage = intage;
      this.handleIntageDataMarketShare(window["weeks"]);
    }
    else
    {
      this.checkIntageFlashAllDataMarketShare();
    }
  }

  public async checkIntageFlashAllDataMarketShare()
  {
    setTimeout(async () => {
      var intage = await IndexDbHelper.Get('IntageFlashAllData');  
      if (intage != null)
      {
        this.intage = intage;
        this.handleIntageDataMarketShare(window["weeks"]);
      }
      else
      {
        this.checkIntageFlashAllDataMarketShare();
      }
    }, 200);
  }

  public handleIntageDataMarketShare(weeks: any)
  {
    var data = this.intage.filter(x=> weeks.includes(x.week));
    this.marketShareData2 = [];
    let totals = [{
      channel: 'OTC Total',
      category: 'Total',
      ty: 0,
      ly: 0,
      tyVolume:0,
      lyVolume:0
    }];
    for(var i=0;i<data.length;i++){
      let row = data[i];
      if(!this.otcSelectedRegion.includes('CCBJI Territory') && !this.otcSelectedRegion.includes(row.region)){
        continue;
      }
      let maker = this.marketShareData2.find(x=> x.maker == row.maker);
      let total = totals.find(x=> x.channel == row.channel && x.category == row.category);
      if(total == null){
        total = {
          channel: row.channel,
          category: row.category,
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
          tyVolume: parseFloat(row.tyVolume),
          lyVolume: parseFloat(row.lyVolume)
        }
        totals.push(total);
      }else{
        total.ty +=parseFloat(row.ty);
        total.ly +=parseFloat(row.ly);
      }
      let categoryTotal = totals.find(x=> x.channel == row.channel && x.category == 'Total');
      if(categoryTotal == null){
        categoryTotal = {
          channel: row.channel,
          category: 'Total',
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
          tyVolume: parseFloat(row.tyVolume),
          lyVolume: parseFloat(row.lyVolume)
        }
        totals.push(categoryTotal);
      }else{
        categoryTotal.ty +=parseFloat(row.ty);
        categoryTotal.ly +=parseFloat(row.ly);
        categoryTotal.tyVolume +=parseFloat(row.tyVolume);
        categoryTotal.lyVolume +=parseFloat(row.lyVolume);
      }
      let channelTotal = totals.find(x=> x.channel == 'OTC Total' && x.category == row.category);
      if(channelTotal == null){
        channelTotal = {
          channel: 'OTC Total',
          category: row.category,
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
          tyVolume: parseFloat(row.tyVolume),
          lyVolume: parseFloat(row.lyVolume)
        }
        totals.push(channelTotal);
      }else{
        channelTotal.ty +=parseFloat(row.ty);
        channelTotal.ly +=parseFloat(row.ly);
        channelTotal.tyVolume +=parseFloat(row.tyVolume);
        channelTotal.lyVolume +=parseFloat(row.lyVolume);
      }

      totals[0].ty +=parseFloat(row.ty);
      totals[0].ly +=parseFloat(row.ly);
      totals[0].tyVolume +=parseFloat(row.tyVolume);
      totals[0].lyVolume +=parseFloat(row.lyVolume);
      
      if(!this.otcSelectedPackageType.includes('All') && !this.otcSelectedPackageType.includes(row.packageType)){
        continue;
      }
      if(maker == null){
        let makerLogo = this.makerLogo.find(x=> x.maker == row.maker);
        maker = {
          maker: row.maker,
          index: makerLogo != null ? makerLogo.index : 100,
          logo: makerLogo != null ? makerLogo.logo: "",
          channels: [{
            channel: 'OTC Total',
            categories: [{
              category : 'Total',
              ty: 0,
              ly: 0,
              totalTy: 0,
              totalLy: 0,
              share: '',
              vsLy: '',
              tyVolume: 0,
              lyVolume: 0,
              totalTyVolume: 0,
              totalLyVolume: 0,
              vsLyVolume: ''
            }]
          },
          {
            channel: 'SMDD',
            categories: [{
              category : 'Total',
              ty: 0,
              ly: 0,
              totalTy: 0,
              totalLy: 0,
              share: '',
              vsLy: '',
              tyVolume: 0,
              lyVolume: 0,
              totalTyVolume: 0,
              totalLyVolume: 0,
              vsLyVolume: ''
            }]
          }]
        };
        this.marketShareData2.push(maker);
      }

      let channel = maker.channels.find(x=> x.channel == row.channel);
      if(channel == null){
        channel = {
          channel: row.channel,
          categories: [
            {
              category: 'Total',
              ty: 0,
              ly: 0,
              totalTy: 0,
              totalLy: 0,
              share: '',
              vsLy: '',
              tyVolume: 0,
              lyVolume: 0,
              totalTyVolume: 0,
              totalLyVolume: 0,
              vsLyVolume: ''
            }
          ]
        };
        maker.channels.push(channel);
      }

      let category = channel.categories.find(x=> x.category == row.category);
      if(category == null){
        category = {
          category: row.category,
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
          totalTy: 0,
          totalLy: 0,
          share: '',
          vsLy: '',
          tyVolume: parseFloat(row.tyVolume),
          lyVolume: parseFloat(row.lyVolume),
          totalTyVolume: 0,
          totalLyVolume: 0,
          vsLyVolume: ''
        };
        channel.categories.push(category);
      }
      else{
        category.ty += parseFloat(row.ty);
        category.ly += parseFloat(row.ly);
        category.tyVolume += parseFloat(row.tyVolume);
        category.lyVolume += parseFloat(row.lyVolume);
      }
      let makerCategory = maker.channels[0].categories.find(x=> x.category == row.category);
      if(makerCategory == null){
        makerCategory = {
          category: row.category,
          ty: parseFloat(row.ty),
          ly: parseFloat(row.ly),
          totalTy: 0,
          totalLy: 0,
          share: '',
          vsLy: '',
          tyVolume: parseFloat(row.tyVolume),
          lyVolume: parseFloat(row.lyVolume),
          totalTyVolume: 0,
          totalLyVolume: 0,
          vsLyVolume: ''
        };
        maker.channels[0].categories.push(makerCategory);
      }
      else{
        makerCategory.ty += parseFloat(row.ty);
        makerCategory.ly += parseFloat(row.ly);
        makerCategory.tyVolume += parseFloat(row.tyVolume);
        makerCategory.lyVolume += parseFloat(row.lyVolume);
      }
      channel.categories[0].ty+= parseFloat(row.ty);
      channel.categories[0].ly+= parseFloat(row.ly);
      channel.categories[0].tyVolume+= parseFloat(row.tyVolume);
      channel.categories[0].lyVolume+= parseFloat(row.lyVolume);
      maker.channels[0].categories[0].ty+= parseFloat(row.ty);
      maker.channels[0].categories[0].ly+= parseFloat(row.ly);
      maker.channels[0].categories[0].tyVolume+= parseFloat(row.tyVolume);
      maker.channels[0].categories[0].lyVolume+= parseFloat(row.lyVolume);
      if(row.channel == 'SM' || row.channel == 'Drug' || row.channel == 'Discounter'){
        maker.channels[1].categories[0].ty+= parseFloat(row.ty);
        maker.channels[1].categories[0].ly+= parseFloat(row.ly);
        maker.channels[1].categories[0].tyVolume+= parseFloat(row.tyVolume);
        maker.channels[1].categories[0].lyVolume+= parseFloat(row.lyVolume);
        let smddCategory = maker.channels[1].categories.find(x=> x.category == row.category);
        if(smddCategory == null){
          smddCategory = {
            category: row.category,
            ty: parseFloat(row.ty),
            ly: parseFloat(row.ly),
            totalTy: 0,
            totalLy: 0,
            share: '',
            vsLy: '',
            tyVolume: parseFloat(row.tyVolume),
            lyVolume: parseFloat(row.lyVolume),
            totalTyVolume: 0,
            totalLyVolume: 0,
            vsLyVolume: ''
          };
          maker.channels[1].categories.push(smddCategory);
        }
        else{
          smddCategory.ty += parseFloat(row.ty);
          smddCategory.ly += parseFloat(row.ly);
          smddCategory.tyVolume += parseFloat(row.tyVolume);
          smddCategory.lyVolume += parseFloat(row.lyVolume);
        }
      }
    }

    for(var i=0;i<this.marketShareData2.length;i++){
      let maker = this.marketShareData2[i];
      for(var j=0;j<maker.channels.length;j++){
        for(var k=0;k<maker.channels[j].categories.length;k++){
          let category = maker.channels[j].categories[k];
          if(maker.channels[j].channel != 'SMDD'){
            let total = totals.find(x=> x.category == category.category && x.channel == maker.channels[j].channel);
            category.totalTy = total.ty;
            category.totalLy = total.ly;
            category.share = category.totalTy == 0 ? "-" : ((category.ty / category.totalTy) * 100).toFixed(1);
            let share_noround =  category.totalTy == 0 ? null : ((category.ty / category.totalTy) * 100) + '';
            let shareLy_noround = category.totalLy == 0 ? null : ((category.ly / category.totalLy) * 100) + '';

            category.vsLy = (share_noround == null || shareLy_noround == null) ? '-' : (parseFloat(share_noround) - parseFloat(shareLy_noround)).toFixed(1);
            category.totalTyVolume = total.tyVolume;
            category.totalLyVolume = total.lyVolume;
            let shareVolume = category.totalTyVolume == 0 ? 0.0 : (category.tyVolume / category.totalTyVolume) * 100;
            let lyShareVolume = category.totalLyVolume == 0 ? 0.0 : (category.lyVolume / category.totalLyVolume) * 100;
            category.vsLyVolume = (shareVolume - lyShareVolume).toFixed(1);
          }
          else{
            let totalList = totals.filter(x=> x.category == category.category && (x.channel == 'SM' || x.channel == 'Drug' || x.channel == 'Discounter'));
            for(var t=0;t<totalList.length;t++){
              let total = totalList[t];
              category.totalTy += total.ty;
              category.totalLy += total.ly;
              category.totalTyVolume += total.tyVolume;
              category.totalLyVolume += total.lyVolume;
            }
            category.share = category.totalTy == 0 ? "-" : ((category.ty / category.totalTy) * 100).toFixed(1);
            let share_noround =  category.totalTy == 0 ? null : ((category.ty / category.totalTy) * 100) + '';
            let shareLy_noround = category.totalLy == 0 ? null : ((category.ly / category.totalLy) * 100) + '';
            category.vsLy = (share_noround == null || shareLy_noround == null) ? '-' : (parseFloat(share_noround) - parseFloat(shareLy_noround)).toFixed(1);
            let shareVolume = category.totalTyVolume == 0 ? 0.0 : (category.tyVolume / category.totalTyVolume) * 100;
            let lyShareVolume = category.totalLyVolume == 0 ? 0.0 : (category.lyVolume / category.totalLyVolume) * 100;
            category.vsLyVolume = (shareVolume - lyShareVolume).toFixed(1);
          }
        }
      }
    }

    this.marketShareData2.sort((a, b) => a.index > b.index ? 1 : -1);
    for(var i=0;i<this.marketShareData2.length;i++){
      let maker = this.marketShareData2[i];
      if(this.otcDisplayChannel == '1'){
        maker.channels = maker.channels.filter(x=> x.channel != 'SM' && x.channel!= 'Drug' && x.channel!= 'Discounter');
      }
      else{
        maker.channels = maker.channels.filter(x=> x.channel != 'SMDD');
      }
    }
    let t1= this;
    setTimeout(() => {
      t1.ready.emit(true);
    });
  }
  public getCategoryColor(category: string){
    return IntageHelper.GetCategoryColor(category);
  }

  public getCategoryDisplayName(category: string){
    return IntageHelper.GetCategoryDisplayName(category);
  }
  public getShareOfCategory(categories: any, category: string){
    return IntageHelper.GetShareOfCategory(categories, category);
  }

  public getVsLyOfCategory(categories: any, category: string){
    return IntageHelper.GetVsLyOfCategory(categories, category);
  }

  public getVsLyOfCategoryForMarketSize(categories: any, category: string){
    return IntageHelper.GetVsLyOfCategoryForMarketSize(categories, category);
  }

  public getImpOfCategory(categories: any, category: string){
    return IntageHelper.GetImpOfCategory(categories, category);
  }
  public onOtcDisplayChannelChange(channelType: string){
    this.otcDisplayChannel = channelType;
    this.handleMarketSize();
    this.handleMarketShare2();
  }

  public onOtcSelectedRegionChange(){
    if(this.otcSelectedRegion.length==0){
      this.otcSelectedRegion = ['CCBJI Territory'];
    }
    this.handleMarketSize();
    this.handleMarketShare2();
  }

  public onOtcSelectedPackageTypeChange(){
    if(this.otcSelectedPackageType.length==0){
      this.otcSelectedPackageType = ['All'];
    }
    this.handleMarketSize();
    this.handleMarketShare2();
  }

  // FPT-MyNT15 [2022/11/30][SENSE][1203444563290052] Intage OTC report add download PNG
  public exportOTCMarketSize(isImage: boolean) {
    const fileName = 'OTC Market Value Share by Category';
    if (isImage) {
      // FPT-ChienNX7 [2022/12/09][SENSE][1203444563290052] Fix bug image download incorrect
      this.scroller.nativeElement.scrollTop = 0;
      this.scroller.nativeElement.scrollLeft = 0;
      setTimeout(() => {
        html2canvas(this.screen.nativeElement).then(canvas => {
          this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
          this.downloadLink.nativeElement.download = fileName;
          this.downloadLink.nativeElement.click();
        });
      }, 500);
    } else {
      let data = [];
      for (var i = 0; i < this.data.length; i++) {
        let channel = this.data[i];
        for (var j = 0; j < channel.categories.length; j++) {
          let category = channel.categories[j];
          data.push({
            week: this.selectedWeek,
            aggregateBy: this.aggregateBy == null ? "wtd" : this.aggregateBy,
            display: this.otcDisplayChannel == "1" ? "Channel Level 1" : "Channel Level 2",
            region: this.otcSelectedRegion,
            packagetype: this.otcSelectedPackageType,
            maker: 'Market Size',
            channel: channel.channel,
            category: category.category,
            ty: category.ty,
            ly: category.ly,
            share: '',
            totalTy: '',
            totalLy: '',
            imp: category.imp,
            vsLy: category.vsLy
          });
        }
      }

      for(var i=0;i<this.marketShareData2.length;i++){
        // FPT-HoiLT2 [20221130][SENSE][1203454213752038]Intage OTC Flash CSV Corrections SMDD Start
        let maker = Object.assign({}, this.marketShareData2[i]);
        if(this.otcDisplayChannel == '1'){
          maker.channels = maker.channels.filter(x=> x.channel != 'SM' && x.channel!= 'Drug' && x.channel!= 'Discounter');
        }
        else{
          maker.channels = maker.channels.filter(x=> x.channel != 'SMDD');
        }
        // FPT-HoiLT2 [20221130][SENSE][1203454213752038]Intage OTC Flash CSV Corrections SMDD End
        for(var j=0;j<maker.channels.length;j++){
          let channel = maker.channels[j];
          for(var k=0;k<channel.categories.length;k++){
            let category = channel.categories[k];
            data.push({
              week: this.selectedWeek,
              aggregateBy: this.aggregateBy == null ? "wtd" : this.aggregateBy,
              display: this.otcDisplayChannel == "1" ? "Channel Level 1" : "Channel Level 2",
              region: this.otcSelectedRegion,
              packagetype: this.otcSelectedPackageType,
              maker: maker.maker,
              channel: channel.channel,
              category: category.category,
              ty: category.ty,
              ly: category.ly,
              share: category.share,
              totalTy: category.totalTy,
              totalLy: category.totalLy,
              imp: '',
              vsLy: '',
              shareDiff: category.vsLy
            });
          }
        }
      }
      new AngularCsv(data, fileName, {
        showLabels: true,
        headers: ["Week", "Aggregate By", "Display", "Region", "Package Type", "Maker", "Channel", "Category", "TY_Value", "LY_Value", "Share_Value", "Total_TY_Value", "Total_LY_Value", "IMP", "% vs LY_Value", "Diff_LY_Value"],
      });
    }
    this.showOptionDownload();
  }

  showOptionDownload() {
    const download = document.getElementById('download-option-market-size');
    if (download.style.display === 'block') {
      download.style.display = 'none';
    } else {
      download.style.display = 'block';
    }
  }

  @ViewChild('pdf_print_area_1', { static: false }) pdf_print_area_1: ElementRef;
  public downloadAsPDF(name) {
    return _downloadAsPDF(name, this.pdf_print_area_1.nativeElement)
  }

}
